module.exports = __webpack_public_path__ + "img/success.28c568e5.png";